import { Box, Button } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { tokens } from "../../theme";
import Header from "../../components/Header";
import { LockOutlined, LockOpenOutlined } from "@mui/icons-material";
import { useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { db, collection, getDocs } from "../../firebase"; 
import { doc, updateDoc } from "firebase/firestore";

const Responders = () => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const querySnapshot = await getDocs(collection(db, "driver")); // Fetch data from 'users' collection
        const userData = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setRows(userData);
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };

    fetchData();
  }, []);

  const toggleBlockStatus = async (userId, isBlocked) => {
    try {
      const userRef = doc(db, "users", userId); // Adjust collection name
      await updateDoc(userRef, { isBlocked: !isBlocked }); // Toggle block status
    } catch (error) {
      console.error("Error updating block status:", error);
    }
  };

  const columns = [
    // { field: "id", headerName: "ID", flex: 0.5 },
    // { field: "registrarId", headerName: "Registrar ID" },
    {
      field: "name",
      headerName: "Name",
      flex: 1,
      cellClassName: "name-column--cell",
    },
    {
      field: "dob",
      headerName: "Age",
      type: "number",
      headerAlign: "left",
      align: "left",
      renderCell: ({ value }) => {
        if (!value) return "N/A"; // Handle missing values
  
        // Split the DD/MM/YYYY format
        const [day, month, year] = value.split("/").map(Number);
        const dobDate = new Date(year, month - 1, day); // Convert to Date object
  
        const today = new Date();
        let age = today.getFullYear() - dobDate.getFullYear();
        const monthDiff = today.getMonth() - dobDate.getMonth();
  
        // Adjust age if the birthday hasn't occurred yet this year
        if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < dobDate.getDate())) {
          age--;
        }
  
        return age;
      },
    },
    {
      field: "phone",
      headerName: "Phone Number",
      flex: 1,
    },
    {
      field: "email",
      headerName: "Email",
      flex: 1,
    },
    
    {
      field: "isBlocked",
      headerName: "Block/Unblock",
      flex: 1,
      renderCell: ({ row }) => {
        return (
          <Box display="flex" justifyContent="center" alignItems="center">
            <Button
              variant="contained"
              color={row.isBlocked ? "error" : "success"}
              startIcon={row.isBlocked ? <LockOutlined /> : <LockOpenOutlined />}
              onClick={() => toggleBlockStatus(row.id, row.isBlocked)}
            >
              {row.isBlocked ? "Unblock" : "Block"}
            </Button>
          </Box>
        );
      },
    },
  ];

  return (
    <Box m="20px">
      <Header
        title="RESPONDER MANAGEMENT"
        subtitle="List of Emergency Responders and Ambulance Services"
      />
      <Box
        m="40px 0 0 0"
        height="75vh"
        sx={{
          "& .MuiDataGrid-root": {
            border: "none",
            fontSize: "14px",
          },
          "& .MuiDataGrid-cell": {
            borderBottom: "none",
            fontSize: "14px",
          },
          "& .name-column--cell": {
            color: colors.greenAccent[300],
            fontWeight: "bold",
          },
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.blueAccent[700],
            color: "#fff",
            fontWeight: "bold",
          },
          "& .MuiDataGrid-footerContainer": {
            borderTop: "none",
            backgroundColor: colors.blueAccent[700],
            color: "#fff",
          },
          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: colors.primary[400],
          },
          "& .MuiDataGrid-row:hover": {
            backgroundColor: colors.primary[600],
          },
          "& .MuiCheckbox-root": {
            color: `${colors.greenAccent[200]} !important`,
          },
        }}
      >
        <DataGrid
          checkboxSelection
          rows={rows}
          columns={columns}
          getRowHeight={() => 55} // Increased row height for better spacing
        />
      </Box>
    </Box>
  );
};

export default Responders;
